import MyBraveStory from '@/components/Exercises/MyBraveStory/MyBraveStory'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(content)/children/exercises/(shared)/my-brave-story/',
)({
  component: RouteComponent,
  head: () => ({
    meta: [
      {
        title: "⁠Are you scared? - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "myBraveStory.title",
    navbar: {
      showTitle: true,
    },
  }),
})

function RouteComponent() {
  return <MyBraveStory />
}
